<mat-card class="p-5 w-[15rem]">
  <mat-card-header>
    <mat-card-title class="text-headline-large px-0">My Account</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Dashboard', targetRouteName: 'DASHBOARD'
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Checked Out', targetRouteName: 'CHECKED_OUT', highlightRouteName: 'CHECKED_OUT_ROOT',
      value: accountStatusSelectors.unresolvedCheckoutCount | select
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Holds', targetRouteName: 'HOLDS', value: accountStatusSelectors.activeHoldsCount | select
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Balance', targetRouteName: 'BALANCE', value: accountStatusSelectors.currentAccountBalance | select | format:'CURRENCY'
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Requests', targetRouteName: 'ITEM_REQUESTS', value: accountStatusSelectors.unresolvedItemRequestCount | select
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'My Profile', targetRouteName: 'MY_PROFILE'
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Related Accounts', targetRouteName: 'RELATED_ACCOUNTS', highlightRouteName: 'RELATED_ACCOUNTS_ROOT'
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Favorites', targetRouteName: 'FAVORITES'
    }"/>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="link; context: {
      label: 'Settings', targetRouteName: 'SETTINGS'
    }"/>
  </mat-card-content>
</mat-card>

<!-- "highlightRouteName" is necessary only if the link will be highlighted for more than one route, rather than just "targetRouteName". -->
<ng-template #link let-label="label" let-targetRouteName="targetRouteName" let-highlightRouteName="highlightRouteName" let-value="value">
  @if ({currentRoute: routerSelectors.routeNameMatchesIncludingChildren(highlightRouteName ?? targetRouteName) | select}; as vm) {
    <!-- eslint-disable-next-line @nx/workspace-mx-use-button-components -- This anchor wraps content that is more than just simple text. -->
    <a [pxNamedRouterLink]="targetRouteName" class="flex flex-row justify-between items-center px-2 py-3 text-title-medium border-r-2"
       [ngClass]="{'border-r-transparent': !vm.currentRoute, 'bg-ref-neutral-variant-95 border-r-primary': vm.currentRoute}">
      <span class="text-title-medium text-on-background">
        {{ label }}
      </span>

      <span class="flex flex-row justify-between items-center gap-x-1 text-primary">
        {{ value ?? '' }}
        <mat-icon class="mat-icon-size-4.5">arrow_forward</mat-icon>
      </span>
    </a>
  }
</ng-template>
